module.exports = __webpack_public_path__ + "img/banner3-min.53fa47dd.jpg";